import React from "react";
import "./Loading.css";

interface LoadingProps {
    size?: "sm" | "md" | "lg";
    text?: string;
    fullScreen?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ size = "md", text, fullScreen = false }) => {
    const sizeClasses = {
        sm: "loading--sm",
        md: "loading--md",
        lg: "loading--lg"
    };

    const content = (
        <div className={`loading ${sizeClasses[size]}`}>
            <div className="loading__spinner">
                <div className="loading__ring"></div>
                <div className="loading__ring"></div>
                <div className="loading__ring"></div>
            </div>
            {text && <p className="loading__text">{text}</p>}
        </div>
    );

    if (fullScreen) {
        return <div className="loading__fullscreen">{content}</div>;
    }

    return content;
};

export default Loading;

// Skeleton Loading Component
interface SkeletonProps {
    width?: string;
    height?: string;
    borderRadius?: string;
    className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({
    width = "100%",
    height = "1rem",
    borderRadius = "4px",
    className = ""
}) => {
    return (
        <div
            className={`skeleton ${className}`}
            style={{ width, height, borderRadius }}
        />
    );
};

// Card Skeleton
export const CardSkeleton: React.FC = () => {
    return (
        <div className="card-skeleton">
            <Skeleton height="200px" borderRadius="12px" />
            <div className="card-skeleton__content">
                <Skeleton width="60%" height="1.25rem" />
                <Skeleton width="80%" height="0.9rem" />
                <Skeleton width="40%" height="1rem" />
            </div>
        </div>
    );
};

// Page Loading
export const PageLoading: React.FC<{ message?: string }> = ({ message = "Yükleniyor..." }) => {
    return (
        <div className="page-loading">
            <div className="page-loading__content">
                <div className="page-loading__logo">
                    <svg viewBox="0 0 100 100" width="60" height="60">
                        <defs>
                            <linearGradient id="loading-grad" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" style={{ stopColor: "#B49B57" }} />
                                <stop offset="100%" style={{ stopColor: "#C8A7E8" }} />
                            </linearGradient>
                        </defs>
                        <circle
                            cx="50"
                            cy="50"
                            r="40"
                            fill="none"
                            stroke="url(#loading-grad)"
                            strokeWidth="4"
                            strokeLinecap="round"
                            strokeDasharray="180 60"
                            className="page-loading__circle"
                        />
                    </svg>
                </div>
                <p className="page-loading__message">{message}</p>
            </div>
        </div>
    );
};
